module.exports = __webpack_public_path__ + "static/media/logo.515e88bc.png";